// resources/js/app.js

// Tailwind/ana css’in build’e girmesi için:
import '../css/app.css'

// Tema css’lerin (istersen app.css içine de alabilirsin)
import 'slick-carousel/slick/slick.css'
import '@fancyapps/fancybox/dist/jquery.fancybox.css'
import '../css/theme/style.css'
import '../css/theme/fancybox.css'

// jQuery'yi Vite üzerinden al ve global'e yaz
import $ from './bootstrap/jquery'

// Sticky (jQuery'siz)
import Sticky from 'sticky-js'
globalThis.Sticky = globalThis.Sticky || Sticky

/**
 * Legacy / jQuery pluginleri: DİNAMİK IMPORT
 * (Böylece jQuery global set edildikten sonra çalışırlar.)
 */
globalThis.__APP_READY__ = (async () => {
    // jQuery pluginleri
    await import('slick-carousel')
    await import('@fancyapps/fancybox')

    // Yerel legacy pluginler (jQuery global bekleyen IIFE dosyaları)
    await import('./theme/nette.js')

    // Echo jQuery bağımlı değilse statik de olur; burada da olabilir

    // DOM hazır
    $(function () {
        if ($.fn.slick && $('.js-slider').length) {
            $('.js-slider').slick({ arrows: true, dots: true, adaptiveHeight: true })
        }

        if ($.fn.navpoints && $('.js-navpoints').length) {
            $('.js-navpoints').navpoints()
        }

        if ($.fancybox && $('[data-fancybox]').length) {
            $('[data-fancybox]').fancybox()
        }

        const StickyCtor = globalThis.Sticky || Sticky
        if (StickyCtor && document.querySelector('.js-sticky')) {
            new StickyCtor('.js-sticky', { marginTop: 16, stickyClass: 'is-sticky' })
        }
    })

    return true
})().catch((e) => {
    console.error('APP_READY boot failed:', e)
    return false
})
